<style src='@/resources/styles/loading.css' scoped></style>

<template>
  <main>
    <div class='inner cover'>
      <div class='loader'>
        <div class='toHide'>
          <h1 id='status' class='status lead'>
            Generating...
          </h1>


         <Spinner />
        </div>
      </div>
    </div>
  </main>
</template>

<script>

  import { mapActions } from 'vuex'
  import Spinner from "../../extended/Spinner";


  export default {
    name: 'GenerateByKeywordView',
    components: {Spinner},

    mounted: function() {
      this.pageLoaded(this.$route);
      const keyword = this.$route.params['keyword'].trim();
      window.console.log("Keyword:", keyword);
      this.process(keyword)

    },

    computed: {
    },

    methods: {

      ...mapActions(['generate', 'pageLoaded']),

      process(keyword) {
        window.console.log("Generating", keyword);
        const payload = {
          keywords: [keyword],
          router: this.$router,
        };


        this.$store.dispatch("generate", payload);
      }
    }
  }
</script>